<template>
<div>
  <div class="card-page-container">
    <div class="mdl-grid fill">
      <div class="mdl-card mdl-cell fill mdl-shadow--2dp">
        <div class="mdl-card__title">
          <h2 class="mdl-card__title-text">{{'payment.label.crypto.title' | label}}</h2>
        </div>
        <div class="mdl-card__supporting-text fill">
          <p v-if="success">{{'payment.label.crypto.success' | label}}</p>
          <p v-else>{{'payment.label.crypto.cancel' | label}}</p>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
  module.exports = {
    ready: function () {
      this.success = this.$route.query.success === 'true'
    },
    data: function () {
      return {
        success: false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// CryptoPaymentResult.vue?30d278c5